import { render, staticRenderFns } from "./CadastreBuildingFieldReferenceList.vue?vue&type=template&id=79907fe4&scoped=true&"
import script from "./CadastreBuildingFieldReferenceList.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingFieldReferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79907fe4",
  null
  
)

export default component.exports